import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import MainReducer from './MainReducer';
import AboutReducer from './AboutReducer';
import PhotographyReducer from './PhotographyReducer';
import ResumeReducer from './ResumeReducer';
import PortfolioReducer from './PortfolioReducer';
import portfolioProjectReducer from './PortfolioProjectReducer';
import LayoutMainReducer from './LayoutMainReducer';
import MenuReducer from './MenuReducer';
import HeaderReducer from './LayoutMainReducer'

const reducers = combineReducers({
    main: MainReducer,
    about: AboutReducer,
    photography: PhotographyReducer,
    portfolio: PortfolioReducer,
    portfolioProject: portfolioProjectReducer,
    resume: ResumeReducer,
    layoutMain: LayoutMainReducer,
    router: routerReducer,
    menu: MenuReducer,
    header: HeaderReducer,
});

export default reducers


// WEBPACK FOOTER //
// ./src/js/reducers/index.js